import { render, staticRenderFns } from "./RollBetsElement.vue?vue&type=template&id=8751696a&scoped=true"
import script from "./RollBetsElement.vue?vue&type=script&lang=js"
export * from "./RollBetsElement.vue?vue&type=script&lang=js"
import style0 from "./RollBetsElement.vue?vue&type=style&index=0&id=8751696a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8751696a",
  null
  
)

export default component.exports